export {
  API_URL,
  EXATO_DIGITAL_API_KEY,
  getServerApiBaseUrl,
  WHITELABEL,
} from './environments';
